module.exports = __webpack_public_path__ + "img/46.b49257dc.jpg";